export default __webpack_public_path__ + "static/media/19.cb056620.mp3";